export default __webpack_public_path__ + "static/fs-goldO-a98a53cb4829657764240998ff46ee6f.png";